import React from "react";
import OwnerStateAchievementsPage from "../owner/OwnerStateAchievementsPage";

export default function State789AchievementsWarRoomPage() {
  return <OwnerStateAchievementsPage />;
}
